import './address-manual-override.component.scss'
import {Address} from "../../../model/Address";

export class AddressManualOverride {

    static instance = {
        template: require('./address-manual-override.component.html'),
        controller: [AddressManualOverride],
        bindings: {
            address: '=',
            onSubmit: '<'
        }
    };

    private address: Address;

    $onInit() {
        console.log(this.address);
    }

    submit = () => {
        //todo show confirmation dialog
        this.onSubmit(this.address)
    };

    private onSubmit: (address: Address) => any;

}